import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 2px solid ${(props: any) => props.theme.colors.ce0e0e0};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: ${(props: any) => props.theme.colors.white};
  box-sizing: border-box;
  overflow: hidden;
  word-wrap: break-word;
`;

export const Content = styled.div`
  padding: 16px;
`; 

export const ContentSection = styled.div`
  display: flex;
  padding: 0;
  gap: 32px;

  @media (max-width: 768px) {
    gap: 16px;
    flex-direction: column;
  }
`;

export const SectionColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 8px;
  min-width: 0;
  overflow: hidden;
`;